// extracted by mini-css-extract-plugin
export var readonly = "_h0-1";
export var star = "_h0-0";